import packageJson from '../../package.json';

/** Strip leading "v" so v5.15.3 and 5.15.3 compare equal. */
export function normalizeAppVersion(version) {
  return String(version || '').trim().replace(/^v/i, '');
}

/** Baked in at build time (GitHub release tag) or local package.json version. */
export const FRONTEND_BUILD_VERSION = normalizeAppVersion(
  process.env.REACT_APP_VERSION || packageJson.version
);

/** Commit SHA baked in by CI; empty for local builds. */
export const FRONTEND_BUILD_ID = String(process.env.REACT_APP_BUILD_ID || '').trim();

export function versionsMatch(a, b) {
  const left = normalizeAppVersion(a);
  const right = normalizeAppVersion(b);
  if (!left || !right) return true;
  return left === right;
}
